import styles from "./Carousel.module.scss";
import { useEffect, useRef, useState } from "react";

const Carousel = () => {
  const intervalTime = 7500;
  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const itemsRef = useRef<HTMLDivElement[]>([]);
  const bulletsRef = useRef<HTMLDivElement[]>([]);

  // Start carousel rotation
  useEffect(() => {
    startCarousel();

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const startCarousel = () => {
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % itemsRef.current.length);
    }, intervalTime);
  };

  const animateCarousel = () => {
    if (window.innerWidth > 960) {
      const item = itemsRef.current[currentIndex];
      if (item) {
        item.style.backgroundSize = "120%";

        setTimeout(() => {
          item.style.transition = `background-size ${intervalTime}ms ease`;
          item.style.backgroundSize = "100%";
        }, 50);
      }
    }
  };

  // Animate carousel item on change
  useEffect(() => {
    animateCarousel();
  }, [currentIndex]);

  const handleBulletClick = (index: number) => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    setCurrentIndex(index);
    startCarousel();
  };

  const currentYear = new Date().getFullYear();
  const xYearsAgo = currentYear - 2007;

  const slides = [
    {
      id: 1,
      title: `Started ${xYearsAgo} years ago`,
      content: "with a small community of believers",
      imgSource: "url(carousel-01.png)",
    },
    {
      id: 2,
      title: "Members opened their doors",
      content: "hosting fellowship in turns",
      imgSource: "url(carousel-02.png)",
    },
    {
      id: 3,
      title: `${xYearsAgo} years after`,
      content: "took a leap of faith starting regular service",
      imgSource: "url(carousel-03.png)",
    },
    {
      id: 4,
      title: "Obeying our calling",
      content: "to be little lights in this world of darkness",
      imgSource: "url(carousel-04.png)",
    },
  ];

  return (
    <section id="carousel" className={styles.carousel}>
      <div className={styles.gallery}>
        {slides.map((slide, i) => (
          <div
            key={slide.id}
            className={`${styles.item} ${i === currentIndex ? styles.active : ""}`}
            ref={(el) => {
              if (el) itemsRef.current[i] = el;
            }}
            style={{
              backgroundImage: slide.imgSource,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className={styles.desc}>
              <h3>{slide.title}</h3>
              <h6>{slide.content}</h6>
            </div>
          </div>
        ))}
      </div>
      <div className={styles.pagination}>
        {slides.map((_, i) => (
          <div
            key={i}
            className={`${styles.bullet} ${i === currentIndex ? styles.active : ""}`}
            onClick={() => handleBulletClick(i)}
            ref={(el) => {
              if (el) bulletsRef.current[i] = el;
            }}
          />
        ))}
      </div>
    </section>
  );
};

export default Carousel;
